import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaHeart, FaShoppingCart } from 'react-icons/fa';
import { useAppContext } from '../context/AppContext';

const Header = () => {
  const { 
    cart, 
    wishlist, 
    toggleWishlistSidebar 
  } = useAppContext();
  const [navActive, setNavActive] = React.useState(false);

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);
  const wishlistCount = wishlist.length;

  return (
    <header>
      <div className="container header-container">
        <Link to="/" className="logo">Home <span>Decors</span></Link>
        <button className="nav-toggle" onClick={toggleNav}>
          <FaBars />
        </button>
        <nav className={navActive ? 'active' : ''} id="mainNav">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><a href="#about">About</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#blog">Blog</a></li>
            <li><a href="#contact">Contact</a></li>
            <li>
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  toggleWishlistSidebar();
                }} 
                className="wishlist-icon"
              >
                <FaHeart />
                <span className="wishlist-count">{wishlistCount}</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;